import * as actionTypes from "../action-types";

export const getReports = payload => ({ type: actionTypes.GET_REPORTS, payload });
export const setReports = payload => ({ type: actionTypes.SET_REPORTS, payload });

export const getBlogs = payload => ({ type: actionTypes.GET_BLOGS, payload });
export const setBlogs = payload => ({ type: actionTypes.SET_BLOGS, payload });

export const getBlogById = payload => ({ type: actionTypes.GET_BLOG_BY_ID, payload });
export const setBlogById = payload => ({ type: actionTypes.SET_BLOG_BY_ID, payload });

export const getSiteSettings = payload => ({ type: actionTypes.GET_SITE_SETTINGS, payload });
export const setSiteSettings = payload => ({ type: actionTypes.SET_SITE_SETTINGS, payload });

export const getAwards = payload => ({ type: actionTypes.GET_AWARDS, payload });
export const setAwards = payload => ({ type: actionTypes.SET_AWARDS, payload });

export const getMediaCoverage = payload => ({ type: actionTypes.GET_MEDIA_COVERAGE, payload });
export const setMediaCoverage = payload => ({ type: actionTypes.SET_MEDIA_COVERAGE, payload });

export const getTestimonialVideos = payload => ({ type: actionTypes.GET_TESTIMONIAL_VIDEOS, payload });
export const setTestimonialVideos = payload => ({ type: actionTypes.SET_TESTIMONIAL_VIDEOS, payload });

export const getCommunityMembers = payload => ({ type: actionTypes.GET_COMMUNITY_MEMBERS, payload });
export const setCommunityMembers = payload => ({ type: actionTypes.SET_COMMUNITY_MEMBERS, payload });
